import { IStore } from 'pages/store-list/store.interface';
import { atom } from 'recoil';

export const selectedStoreIdState = atom<IStore | null>({
  key: 'selectedStoreIdState', // unique ID (with respect to other atoms/selectors)
  default: null
});


